import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-redirect',
  template: '',
})
export class RedirectComponent {
  constructor(
    private route: ActivatedRoute,
  ) {
    const target = this.route.snapshot.data['target'];

    if (target === 'admin') {
      window.location.href = 'https://adminv2.back2action.de';
    }
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src3658806670/src/client/web-client/src/app/pages/redirect/redirect.component.ts